<div class="formula-query-builder flex flex-col gap-3 min-w-0" data-test="formula-query-builder">
  <div class="fqb-header flex items-center gap-3">
    <mat-icon class="fqb-header__icon">functions</mat-icon>
    <span class="fqb-header__title">{{ 'I18N_FORMULA.TITLE' | translate }}</span>

    <!-- Info icon button — opens the help guide overlay on hover -->
    <mat-icon
      class="fqb-header__help-icon cursor-pointer"
      [class.fqb-header__help-icon--active]="showHelpGuide()"
      cdkOverlayOrigin
      #helpOrigin="cdkOverlayOrigin"
      (click)="buttonHovered.set(!buttonHovered())"
      [attr.aria-label]="'I18N_FORMULA.HELP_GUIDE.BUTTON_ARIA_LABEL' | translate"
      [attr.aria-expanded]="showHelpGuide()"
      data-test="formula-query-builder-help-icon"
    >{{ showHelpGuide() ? 'info' : 'info_outline' }}</mat-icon>

    @if (showToggleMode()) {
      <mat-button-toggle-group
        class="fqb-header__toggle"
        [hideSingleSelectionIndicator]="true"
        [value]="mode()"
        (change)="onModeChange($event.value)"
        data-test="formula-query-builder-mode-toggle"
      >
        <mat-button-toggle value="text" data-test="formula-query-builder-mode-text">
          <mat-icon>code</mat-icon>
          <span>{{ 'I18N_FORMULA.MODE_TEXT' | translate }}</span>
        </mat-button-toggle>
        <mat-button-toggle value="visual" data-test="formula-query-builder-mode-visual">
          <mat-icon>dashboard_customize</mat-icon>
          <span>{{ 'I18N_FORMULA.MODE_VISUAL' | translate }}</span>
        </mat-button-toggle>
      </mat-button-toggle-group>
    }
  </div>

  <!-- Help guide connected overlay — anchored to the info button, stays open while hovered -->
  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="helpOrigin"
    [cdkConnectedOverlayOpen]="showHelpGuide()"
    [cdkConnectedOverlayPositions]="helpGuidePositions"
    [cdkConnectedOverlayHasBackdrop]="false"
    [cdkConnectedOverlayPanelClass]="'fqb-help-overlay-panel'"
    [cdkConnectedOverlayFlexibleDimensions]="true"
    [cdkConnectedOverlayGrowAfterOpen]="true"
    [cdkConnectedOverlayViewportMargin]="8"
    (overlayOutsideClick)="onHelpGuideDetach()"
    (detach)="onHelpGuideDetach()"
  >
    <div
      class="fqb-help-overlay-content w-[min(480px,calc(100vw-16px))]"
      (mouseenter)="overlayHovered.set(true)"
      (mouseleave)="overlayHovered.set(false)"
      data-test="formula-query-builder-help-guide"
    >
      <iot-platform-ui-formula-help-guide [config]="config()" />
    </div>
  </ng-template>

  <div class="fqb-body flex flex-col gap-4 min-h-0">
    <div class="fqb-editor min-w-0 flex flex-col">
      @if (mode() === 'text') {
        <iot-platform-ui-formula-editor
          data-test="formula-query-builder-editor"
          [variables]="variables()"
          [formula]="formula()"
          [config]="config()"
          [maxLength]="maxLength()"
          (formulaChange)="onFormulaChange($event)"
          (validationChange)="onValidationChange($event)"
        />
      }
      @if (mode() === 'visual') {
        <iot-platform-ui-formula-builder
          data-test="formula-query-builder-builder"
          [variables]="variables()"
          [formula]="formula()"
          [config]="config()"
          (formulaChange)="onFormulaChange($event)"
        />
      }
    </div>
  </div>

  <div class="fqb-preview flex items-center gap-3 py-2 rounded-md" data-test="formula-query-builder-preview">
    <iot-platform-ui-formula-preview
      class="fqb-preview__output flex-1 min-w-0"
      [formula]="formula()"
      [variables]="variables()"
    />
  </div>

  <iot-platform-ui-formula-evaluation-result
    [evaluationResult]="currentEvalResult()"
    [validResult]="!!validationResult()?.valid"
    data-test="formula-query-builder-evaluation"
  />
</div>

